import { useTranslation } from "react-i18next";

import ActionButtonLayout from "./ActionButtonLayout";

function DeleteApproverButtonLayout ( props ) {

    const { t } = useTranslation();

    return <ActionButtonLayout {...props}>{t("buttonName.delApprover")}</ActionButtonLayout>;

}

export default DeleteApproverButtonLayout;

